import React from 'react';
import Link from 'next/link';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Logo from './Logo';
import { HUB_HEADER_HEIGHT, HUB_HEADER_ID_SELECTOR } from '../../../const/responsive';
import { useHubLayout } from '../../../hooks/useHubLayout';
import { useTableHashData } from '../../../hooks/useTableHashData';

function Header() {
  const { backUrl, backTitle } = useHubLayout();
  const {
    tableHash,
    settings: {
      logo, logoWidth, logoHeight, company_name: companyName,
    },
  } = useTableHashData();

  const showBack = backUrl && backTitle;

  return (
    <header
      className="container py-3 px-4 d-flex align-items-center"
      id={HUB_HEADER_ID_SELECTOR}
      style={{ height: HUB_HEADER_HEIGHT }}
    >
      {showBack && (
        <Link href={backUrl} className="d-flex align-items-center text-decoration-none text-body" data-testid="back_btn">
          <FontAwesomeIcon icon={faArrowLeft} width={20} height={20} />
          <span className="ms-2 fs-5" data-testid="back-title">{backTitle}</span>
        </Link>
      )}
      {!showBack && (
        <Logo href={`/hub/${tableHash}`} src={logo} width={logoWidth} heigth={logoHeight} title={companyName} />
      )}
    </header>
  );
}

export default Header;
